import { createFeatureSelector, createSelector } from "@ngrx/store";
import { SharedState } from "./shared.state";

export const SHARED_STATE_NAME = 'shared';

const getSharedState = createFeatureSelector<SharedState>(SHARED_STATE_NAME);

export const loadingStatus = createSelector(getSharedState, (state) => state.loading);
export const enquiryId = createSelector(getSharedState, (state) => {
    return state.enquiry_id;
});

export const cityList = createSelector(getSharedState, (state) => {
    return state.city_list;
});

export const getQuote = createSelector(getSharedState, (state) => {
    return state.quote_data;
});

export const getContactDetails = createSelector(getSharedState, (state) => {
    return state.quote_data.contact_details;
});

export const allApiStatus = createSelector(getSharedState, (state) => {
    return state.all_api_respons_status;
});